import { Injectable } from '@angular/core'
import { Select, State, Action, StateContext, Selector, NgxsOnInit, Store, NgxsSimpleChange } from '@ngxs/store'
import { Observable } from 'rxjs';
import { UserState } from 'src/app/state-man/state/user.state';
import { User } from 'src/app/state-man/models/user.model';
import { LocationActions } from '../actions/location.actions';
import { Location } from '../models/location.model';
import { LocationService } from 'src/app/services/location.service';
import { StorageService } from 'src/app/services/storage.service';
import { stateContentChanged } from './state-content-changed'

export class LocationStateModel {
    is_refreshing: boolean
    location: Location[]
}

@State<LocationStateModel>({
    name: 'location',
    defaults: {
        is_refreshing: true,
        location: []
    }
})
@Injectable()
export class LocationState implements NgxsOnInit {
    @Select(UserState.getUser) user$: Observable<User>

    constructor(        
        private locationService: LocationService,
        private store: Store,
        private storageService: StorageService
    ) {}

    async ngxsOnInit(ctx: StateContext<LocationStateModel>) {                
        this.user$.subscribe(async (user: User) => {            
            if (user.is_logged_in) {     
                this.storageService.events.subscribe(async (status: any) => {
                    if (this.storageService.is_initialized) {
                        await this.reloadStateFromStorage()                        
                    }
                })                           
            }
        }) 
    }

    async ngxsOnChanges(change: NgxsSimpleChange) {          
        if (this.storageService.is_initialized && stateContentChanged(change)) {
            const state_model: LocationStateModel = change.currentValue
            this.storageService.set('locations', JSON.stringify(state_model))    
        }    
    }

    async reloadStateFromStorage() {        
        const json = await this.storageService.get('locations');        
        if (json) {
            const state_model: LocationStateModel = JSON.parse(json)
            if (state_model) {
                this.store.dispatch(new LocationActions.Init(state_model));
                return
            }
        }
        this.store.dispatch(new LocationActions.Refresh())
    }

    async reloadStateFromApi() : Promise<boolean> {    
        const objs = await this.locationService.getAll()    
        if (objs != null) {
          // The service has already run buildMany over the response, so the
          // rows arriving here are built models. Building them a second time
          // allocated a duplicate object for every row and, where buildOne
          // rebuilds children, re-walked those too.
          this.store.dispatch(new LocationActions.Set(objs))
          return true
        }
        return false
    }
  
    @Selector()
    static getState(state: LocationStateModel) {
        return state
    }

    @Selector()
    static getIsRefreshing(state: LocationStateModel) {
        return state.is_refreshing
    }

    @Selector()
    static getAll(state: LocationStateModel) {
        return state.location
    }

    @Action(LocationActions.Refresh)
    async refresh({patchState}: StateContext<LocationStateModel>, {  }:LocationActions.Refresh) {
        patchState({is_refreshing: true})
        if (!await this.reloadStateFromApi()) {            
            patchState({is_refreshing: false})
        }
    }

    @Action(LocationActions.Init)
    init({setState, getState}: StateContext<LocationStateModel>, { payload }:LocationActions.Init) {                  
        const state = getState()
        payload.is_refreshing = state.is_refreshing
        setState(payload)
        this.store.dispatch(new LocationActions.Refresh())
    }
    
    @Action(LocationActions.Set)
    set({setState}: StateContext<LocationStateModel>, { payload }:LocationActions.Set) {             
        setState({      
            is_refreshing: false,      
            location: payload
        })
    }
}
